import React, { useEffect, useState } from 'react';
import PageHeader from '../../shared/page-header/PageHeader';
import LeadModal from './LeadModal';
import LeadGrid from './LeadGrid';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import axios from 'axios';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts';
import { getModulePermissions } from '../../utils/permissionHelper'
import { logAuditEvent } from '../../utils/auditLogger';

function LeadMain(props) {
  const [getLeadList, setLeadList] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [alert, setAlert] = useState(null);
  const [getSelectedInvestment, setSelectedInvestment] = useState("");
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Lead';

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add lead modal');
  }

  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
     const modulePermissions = getModulePermissions(props.Module);
       setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchLead();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Lead');
  }, [moduleName]);

  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const leadModel = data;
      if (leadModel) {
        logAuditEvent(moduleName, 'Save Lead Attempt', leadModel.LeadId ? `LeadId=${leadModel.LeadId}` : 'Creating new lead');
        let leadDetails = {
          LeadId: null,
          ClientName: leadModel.ClientName || "",
          MobileNumber: leadModel.MobileNumber || "",
          EmailId: leadModel.EmailId || "",
          Description: leadModel.Description || "",
          ClientCompanyTypeIds: JSON.stringify(leadModel.ClientCompanyTypeIds || []),
          UserId: getStorageValues('userId')
        };

        if (validation(leadDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveLeadDetails",
              leadDetails
            );

            if (response.status === 200) {
              if (response.data.data[0].success === 1) {
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'Lead Saved', response.data.data[0].message || 'Success');
                fetchLead();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            }
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'Lead Save Failed', error.message || 'Unknown error');
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    }
  } // ✅ properly closed onSubmit function

  function validation(leadDetails) {
    let isValid = true;

    if (!leadDetails) {
      CreateAlert("Some problem fetching user details entered by the user!!", "Error", setAlert);
      return false;
    }

    if (!leadDetails.ClientName) {
      CreateAlert("Please enter client name!!", "Warning", setAlert);
      return false;
    }

    if (!leadDetails.MobileNumber) {
      CreateAlert("Please enter Mobile Number!!", "Warning", setAlert);
      return false;
    }

    if (!leadDetails.EmailId) {
      CreateAlert("Please enter email id!!", "Warning", setAlert);
      return false;
    }
    var array = JSON.parse(leadDetails.ClientCompanyTypeIds);
     if (array.length <= 0) {
      CreateAlert("Please enter Product Investment!", "Warning", setAlert);
      return false;
    }


    return isValid;
  }

  const fetchLead = async () => {
    try {
      const LeadDetails = { UserId: getStorageValues('userId') };
      const response = await axios.get(getApiBaseUrl() + "/leadList", { params: LeadDetails });

      if (response.status === 200) {
        setLeadList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <LeadGrid LeadData={getLeadList} fetchLead={fetchLead} UserPermissions={getUserModulePermission}/>
      <LeadModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default LeadMain;
